/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import orderClasses from "../../orders/orders.module.css";
import reportClasses from "../reports.module.css";
import PartSearchTable from "./partSearchResult";
import Input from "../../../../component/inputpm";
import Loader from "../../../../component/loader";
import ResendDialog from "../../order/resendDialog";
import IconButton from "@mui/material/IconButton";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import Select from "@mui/material/Select";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import { withTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";

import TextField from "@mui/material/TextField";
import moment from "moment";
import Breadcrumb from "../../../../component/breadcrumb";
import Paper from "@mui/material/Paper";
import { SearchIcon, ClearIcon } from "../../../../component/icons/icons";
import { Grid } from "@mui/material";
import jp from "jsonpath";
import {formatDate} from "../../../../helper/dateFormatter";

// Manage order page class
class PartSearch extends Component {
  // Declare property values that belongs to the component
  state = {
    orders: [],
    parts: [],
    keywords: "",
    recordCount: 50,
    orderId: "",
    customerName: "",
    customerBAN: "",
    orderStatus: "",
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalOrderCount: 0,
    loading: true,
    actionOrderId: "",
    isMailDialog: false,
    sortBy: "orderDate",
    sortOrder: "DESC",
    controls: true,
    orderType: "",
    amount: "",
    orderFromDate: "",
    orderToDate: "",
    clientName: "",

    orderTypeList: [
      {
        name: "All",
        value: "",
      },
      {
        name: "Sales",
        value: "SALES_ORDER",
      },
      {
        name: "Purchase",
        value: "PURCHASE_ORDER",
      },
    ],
    // Order status list
    statusList: [],
    bread: [{ title: this.props.t("PART_SEARCH"), url: "/partSearch" }],
    today: moment(new Date()).format("yyyy-MM-DD"),
    importPartList: [],
  };

  importSelectedItems = () => {
    let itemsNameToImport = jp.query(this.state.parts, "$..[?(@.import)]");
    if (itemsNameToImport.length > 0) {
      let importedData = {};
      let importList = [];
      for (let itemToImport of itemsNameToImport) {
        let tempComp = {};
        tempComp.name = itemToImport.ProductDescription.substring(0, 100);
        tempComp.featureCode = itemToImport.DigiKeyPartNumber;
        tempComp.description = itemToImport.ProductDescription;
        tempComp.priceType = "NRC";
        tempComp.price = itemToImport.UnitPrice;
        tempComp.variants = [];
        tempComp.assembly = false;
        tempComp.physical = true;
        tempComp.inventoryItemType = "NON_SERIALIZED_ITEM";
        tempComp.componentType = "PROD_COMP_ADDON";
        importList.push(tempComp);
      }
      let payload = {
        components: importList,
      };

      // Send request to import the data
      BusApiCall(
        "POST",
        `${constants.busInternalUrl}/passthru/IMPORT_COMPONENTS/endpoint`,
        payload,
      )
        .then((res) => {
          if (res.data && res.data.code) {
            if (
              res.data.message === "Feature code already exist, try another'"
            ) {
              this.props.setErrorMessage(
                "Partial or complete set of components have already been imported. ",
                false,
              );
            } else {
              this.props.setErrorMessage(res.data.message, false);
            }
          } else {
            this.props.setErrorMessage(res.data.message, true);
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        });
    } else {
      this.props.setErrorMessage("No items selected to import.", false);
    }
  };

  updateImportSelection = (number) => {
    let importPartListProxy = [...this.state.parts];
    let pIndex = importPartListProxy.findIndex(
      (a) => a.DigiKeyPartNumber === number,
    );
    if (pIndex >= 0) {
      importPartListProxy[pIndex].import = !importPartListProxy[pIndex].import;
    }
    this.setState({
      parts: importPartListProxy,
    });
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_ORDER_STATUSES/endpoint`,
      {},
    ).then((res) => {
      let list = res.data;
      let all = {
        name: this.props.t("All Orders"),
        value: "All Orders",
      };
      list.unshift(all);
      this.setState({
        statusList: res.data,
      });
    });
    let initialFilters = JSON.parse(localStorage.getItem("orderFilters"));
    if (initialFilters) {
      this.setState(
        {
          rowsPerPage: initialFilters.rowsPerPage,
          startRecord: initialFilters.startRecord,
          page: initialFilters.page,
          sortBy: initialFilters.sortBy,
          sortOrder: initialFilters.sortOrder,
          orderId: initialFilters.orderId,
          orderStatus: initialFilters.orderStatus,
          customerBAN: initialFilters.customerBAN,
          customerName: initialFilters.customerName,
          amount: initialFilters.amount,
          orderFromDate: this.state.orderFromDate,
          orderToDate: this.state.orderToDate,
          orderType: initialFilters.orderType,
          clientName: initialFilters.clientName,
        },
        () => {
          this.getParts();
        },
      );
    } else {
      this.doNothing();
    }
  }

  doNothing = () => {
    this.setState({
      parts: [],
      importPartList: [],
      loading: false,
    });
  };

  getParts = () => {
    // START: Store order filters data
    let partFilters = {
      keywords: this.state.keywords,
      recordCount: this.state.recordCount,
    };
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    this.setState({
      loading: true,
    });
    let filters = `keywords=${encodeURIComponent(partFilters.keywords)}&recordCount=${encodeURIComponent(partFilters.recordCount)}`;
    localStorage.setItem("partFilters", JSON.stringify(filters));

    BusApiCall(
      "GET",
      `${constants.busV4Url}/parts?${filters}`,
      {},
      pageOptions,
    ).then((res) => {
      let data = res.data.Products;
      if (data.length > 0) {
        let importPartListProxy = JSON.parse(JSON.stringify(data));
        let tempData = JSON.parse(JSON.stringify(data));
        tempData.map((obj) => {
          obj.import = false;
        });
        this.setState({
          parts: tempData,
          importPartList: importPartListProxy,
          loading: false,
        });
      } else {
        this.setState({
          parts: [],
          importPartList: [],
          loading: false,
        });
      }
    });
  };

  // Fetch orders list
  getOrders = () => {
    this.setState({
      loading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    // START: Store order filters data
    let partFilters = {
      keywords: this.state.keywords,
      recordCount: this.state.recordCount,
    };
    let orderFilters = {
      rowsPerPage: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
      page: this.state.page,
      sortBy: this.state.sortBy,
      sortOrder: this.state.sortOrder,

      orderId: this.state.orderId,
      orderStatus:
        this.state.orderStatus === "All Orders" ? "" : this.state.orderStatus,
      customerBAN: this.state.customerBAN,
      customerName: this.state.customerName,
      amount: this.state.amount,
      orderFromDate: this.state.orderFromDate
        ? formatDate(this.state.orderFromDate)
        : "",
      orderToDate: this.state.orderToDate
        ? formatDate(this.state.orderToDate)
        : "",
      clientName: this.state.clientName,
    };
    localStorage.setItem("orderFilters", JSON.stringify(orderFilters));
    localStorage.setItem("partFilters", JSON.stringify(partFilters));
    // END: Store order filters data
    let filters = `sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&orderId=${this.state.orderId}&orderStatus=${encodeURIComponent(this.state.orderStatus)}&customerName=${this.state.customerName}&customerBan=${this.state.customerBAN}&clientName=${this.state.clientName ? this.state.clientName : ""}&amount=${this.state.amount ? this.state.amount : ""}&from=${encodeURIComponent(orderFilters.orderFromDate)}&to=${encodeURIComponent(orderFilters.orderToDate)}`;
    BusApiCall(
      "GET",
      `${constants.busV4Url}/orders?${filters}`,
      {},
      pageOptions,
    )
      .then((res) => {
        let data = res.data;
        if (data.length > 0) {
          for (let item of data) {
            item.accountName = item.customer.companyName;
            item.ban = item.customer.ban;
            // Check whether the order is auto-activated or not
            // for (let userItem of item.userData) {
            //     if (userItem.name === 'autoActivatable') {
            //         item.autoActivatable = userItem.value
            //     }
            // }
          }
          this.setState({
            orders: data,
            totalOrderCount: +res.headers["x-total-count"],
            loading: false,
          });
        } else {
          this.setState({
            orders: [],
            totalOrderCount: 0,
            loading: false,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  // Update state data on input change
  onChange = (e) => {
    if (e.target.name === "orderFromDate") {
      this.setState({
        orderToDate: "",
      });
    }
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Open resend confirmation email modal
  openResendDialog = (orderId) => {
    this.setState({
      isMailDialog: true,
      actionOrderId: orderId,
    });
  };

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Close confirmation email dialog
  closeMailDialog = () => {
    this.setState({
      isMailDialog: false,
      actionOrderId: "",
    });
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getOrders();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getOrders();
        },
      );
    }
  };

  // Search/Filter orders
  filterOrderTable = () => {
    this.setState(
      {
        keywords: this.state.keywords,
        recordCount: this.state.recordCount,
        // page: 1,
        // startRecord: 1,
        // orderId: this.state.orderId,
        // customerName: this.state.customerName,
        // customerBAN: this.state.customerBAN,
        // orderStatus: this.state.orderStatus,
        // orderType: this.state.orderType,
        // amount: this.state.amount,
        // orderFromDate: this.state.orderFromDate,
        // orderToDate: this.state.orderToDate,
        // clientName: this.state.clientName
      },
      () => {
        this.getParts();
      },
    );
  };

  // Clear all search filters
  clearOrderTableSearch = () => {
    this.setState(
      {
        orderId: "",
        customerName: "",
        customerBAN: "",
        orderStatus: "",
        orderType: "",
        amount: "",
        clientName: "",
        orderFromDate: "",
        orderToDate: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Clear all search filters and refeesh data
  refreshOrderTableSearch = () => {
    this.setState(
      {
        orderId: "",
        customerName: "",
        customerBAN: "",
        orderStatus: "",
        orderType: "",
        amount: "",
        orderFromDate: "",
        orderToDate: "",
        clientName: "",
        page: 1,
        startRecord: 1,
        sortBy: "orderDate",
        sortOrder: "DESC",
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Search orders on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterOrderTable();
    }
  };

  classes = { ...orderClasses, ...reportClasses };

  // Render order view

  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main>
          <Paper className="tablePaper">
            {/* Search filters start */}
            <div
              className={this.classes.searchOuterDiv}
              style={{ marginBottom: "5px" }}
            >
              <div className={this.classes.searchInputDiv}>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("KEYWORDS")}
                  value={this.state.keywords}
                  name={"keywords"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>

              <div className={this.classes.searchInputDiv}>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("RECORD_COUNT")}
                  value={this.state.recordCount}
                  name={"recordCount"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div className={this.classes.searchInputDiv}></div>
              {}
              <div
                className={`${this.classes.searchInputDiv} customDateReportFilterInput`}
              ></div>

              <div
                className={`${this.classes.searchInputDiv} customDateReportFilterInput`}
              ></div>
              {/* <div className={this.classes.searchOrderLabelOuter} style={{ paddingRight: 0 }}>
                                <div className={this.classes.searchOrderLabelInner} style={{ paddingRight: 0 }}> */}
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <Tooltip title={t("SEARCH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.filterOrderTable}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title={t("CLEAR")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.clearOrderTableSearch}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
                {}
              </div>
              {/* </div> */}
            </div>
            {/* Search filters end */}

            {/* Order table component */}
            <PartSearchTable
              //orderId={this.state.orderId}
              // customerName={this.state.customerName}
              //customerBAN={this.state.customerBAN}
              parts={this.state.parts}
              orders={this.state.orders}
              openResendDialog={this.openResendDialog}
              rowsPerPage={this.state.rowsPerPage}
              totalOrderCount={this.state.totalOrderCount}
              page={this.state.page}
              sortBy={this.state.sortBy}
              sortOrder={this.state.sortOrder}
              updateSorting={this.updateSorting}
              handleChangePage={this.handleChangePage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              controls={this.state.controls}
              loggedInUserType={this.props.loggedInUserType}
              updateImportSelection={this.updateImportSelection}
              importSelectedItems={this.importSelectedItems}
            />
          </Paper>
          {/* Resend confirmation dialog component */}
          <ResendDialog
            isOpen={this.state.isMailDialog}
            close={this.closeMailDialog}
            orderId={this.state.actionOrderId}
          />
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(PartSearch));
